// import vue from 'vue'
import { createStore } from 'vuex'
// import axios from 'axios'
// import apiMarket from '@/config/apiMarket.js'

export default createStore({
   state: {
      allLanguages: '',
      allCountries: '',
      allCurrencies: '',

      SelectLanguage: {
         code: 'en',
         flag: '',
         language: ''
      },

      profile: {},
      statusLogin: false,
      phaseCurrent: '',

      myBusiness: '',

      // cart: [
      //    {
      //       url: "",
      //       thumbs: "",
      //       name: "",
      //       brand: "",
      //       store: "",
      //       price: ""
      //    }
      // ]
   },
   
   mutations: {
      allLanguages(state, value){
         state.allLanguages = value
      },
      allCountries(state, value){
         state.allCountries = value
      },
      allCurrencies(state, value){
         state.allCurrencies = value
      },
      preLanguage(state,code){
         state.SelectLanguage.code = code
      },
      preLanguageFlag(state,flag){
         state.SelectLanguage.flag = flag
      },
      preLanguageName(state,language){
         state.SelectLanguage.language = language
      },
      changeLanguage(state, value){
         state.SelectLanguage = value
      },
      errorLogin(state, value){
         state.statusLogin = value
      },
      profile(state, value){
         state.profile = value
      },
      loginStatus(state, value){
         state.statusLogin = value
      },
      validatePhoneNumber(state, value){
         state.profile.profile_phone_number_verified = value
      },
      phaseCurrent(state, value){
         state.phaseCurrent = value
      },
      myBusiness(state, value){
         state.myBusiness = value
      },
      // minicart(state, value){
      //    state.cart = value
      // },
   },
   actions: {
      // addCart ({ item }) {
      //    item.commit('minicart')
      // }

      // test ({commit}){
      //    return axios.get(apiPlatform('api/v1/platform/language/dne_market')).then((result) => {
      //       commit('changeLanguage',result.data)
      //    })
      // }
        
   },
   modules: {
      
   },
   getters: {
      
   }
})
